/*  eslint-disable vue/one-component-per-file */
/*  eslint-disable vue/component-definition-name-casing */
import { createApp, markRaw } from 'vue'
import AlpineFloatingUI from '@awcodes/alpine-floating-ui'
import * as Sentry from '@sentry/vue'
import VueDndKit from '@vue-dnd-kit/core'
import { MotionPlugin } from '@vueuse/motion'
import Alpine from 'alpinejs'
import * as echarts from 'echarts'
import { transform } from 'echarts-stat'
import flatpickr from 'flatpickr'
import { createPinia } from 'pinia'
// Filament v3 handles its own Alpine plugins via the panel provider
import '../css/app.css'
import './bootstrap'
import { ScalerChartBuilder } from './scaler-chart-builder'
import AppVue from './vue/App.vue'
import ContextMenu from './vue/components/lumi/ContextMenu.vue'
import canAccessFeaturePlugin from './vue/plugins/canAccessFeature.ts'
import hasPermission from './vue/plugins/hasPermission.ts'
import router from './vue/router/router.ts'

echarts.registerTransform(transform.regression)

window.ScalerChartBuilder = ScalerChartBuilder
window.echarts = echarts

Alpine.plugin(AlpineFloatingUI)

window.Alpine = Alpine
window.flatpickr = flatpickr
flatpickr.setDefaults({ allowInput: true })

Alpine.start()

flatpickr('.datepicker')

const pinia = createPinia()
pinia.use(({ store }) => {
    store.$router = markRaw(router)
})

const mainApp = createApp({})
mainApp.use(router)
mainApp.use(pinia)
mainApp.component('AppVue', AppVue)
mainApp.component('ContextMenu', ContextMenu)
mainApp.use(canAccessFeaturePlugin)
mainApp.use(hasPermission)
mainApp.use(MotionPlugin)
mainApp.use(VueDndKit)

Sentry.init({
    app: [
        mainApp,
    ],
    integrations: [
        Sentry.browserTracingIntegration({
            router,
        }),
    ],
    tracesSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 0.7 : 1.0,
    dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
    environment: import.meta.env.VITE_APP_ENV,
    // Enable Spotlight for local development debugging
    spotlight: import.meta.env.VITE_SENTRY_SPOTLIGHT === 'true' || false,
    // Enable trace propagation for distributed tracing
    tracePropagationTargets: ['localhost', 'app.scaler.test', /^\//],
    beforeSend(event) {
        const frames = event.exception?.values?.flatMap(
            value => value.stacktrace?.frames ?? [],
        ) ?? []

        if (frames.some(frame =>
            frame.filename?.startsWith('chrome-extension://')
            || frame.filename?.startsWith('moz-extension://')
            || frame.filename?.startsWith('safari-extension://'),
        )) {
            return null
        }

        return event
    },
})

mainApp.mount('#main-app')
